import {
    Grid, Menu, Breadcrumb, Tab, Label, Icon
} from 'semantic-ui-react'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';

import {
    permissoesListUsuariosMGRAction
} from '../../actions/PermissoesActions';
import Criarusuario from './CriarUsuario';

function Painel(props) {
    useEffect(() => {
        permissoesListUsuariosMGRAction();
    }, [])

    const { permissoesListUsuariosMGRAction } = props;
    const { usuarios } = props;

    let panes = [
        {
            menuItem: <Menu.Item key='TABpendente'><Icon name='add user' />Criar usuario<Label color='red'>{usuarios.length}</Label></Menu.Item>,
            render: () =>
                <Criarusuario
                />,
        },
    ]


    return (
        <div style={{ padding: '1em 0' }}>
            <Menu stackable size='mini' style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}>
                <Menu.Item>
                    <Breadcrumb size='mini'>
                        <Breadcrumb.Section href="/Home">Home</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section active>Permissões</Breadcrumb.Section>
                    </Breadcrumb>
                </Menu.Item>
            </Menu>
            <div>
                <Grid columns={1} doubling>
                    <Grid.Column>
                        <Tab panes={panes} />
                    </Grid.Column>
                </Grid>
            
            </div>

            <style>{`

                /*-------------------------------*/
                /*Menu Superior*/


                .ui.mini.menu>.item{
                    padding: 0;
                }

                .ui.breadcrumb .section {
                    padding: 1.5em 1.5em !important;
                }
                
                .ui.breadcrumb .section:first-child {
                    padding-right: 0 !important;
                    border-radius: 0 0 0 5px !important;
                }
                    

                .ui.breadcrumb .active.section {
                    background-color: #1884af !important;
                    color: #fff !important;
                }
            `}</style>


        </div>
    );
}

const mapStateToProps = (state) => ({
    usuarios: state.PermissoesReducer.usuarios

})
export default withRouter(connect(mapStateToProps, {
    permissoesListUsuariosMGRAction,
}
)(Painel));